import { useModalStore } from '@/shared/lib';
import { GenerateIncomeStatementModal } from '../ui';

interface Props {
  onBack: () => void;
}

const useGenerateIncomeStatementModal = () => {
  const { showDialogComponent } = useModalStore();

  const openGenerateIncomeStatementModal = ({ onBack }: Props) => {
    showDialogComponent({
      component: <GenerateIncomeStatementModal onBack={onBack} />,
    });
  };

  return { openGenerateIncomeStatementModal };
};

export { useGenerateIncomeStatementModal };
